export const club = {
  // Common
  clubs: "Clubs",
  club: "Club",
  city: "City",
  members: "members",
  member: "member",
  wins: "Wins",
  losses: "Losses",
  draws: "Draws",
  record: "Record",
  invite: "Invite",
  inviteCode: "Invite Code",
  copyLink: "Copy Link",
  inviteLinkCopied: "Invite link copied!",

  list: {
    title: "Clubs",
    subtitle: "Tennis communities you belong to.",
    myClubs: "My Clubs",
    clubsInCity: "Clubs in {{city}}",
    create: "Create Club",
    join: "Join",
    joinCodePlaceholder: "Invite code",
    empty: "You haven't joined any clubs yet.",
    emptyHint: "Get an invite code from a club organizer, or start your own.",
  },

  new: {
    title: "New Club",
    subtitle: "Start a tennis community for your city.",
    name: "Club name",
    namePlaceholder: "e.g. Toronto Chinese Tennis Club",
    country: "Country",
    city: "City",
    selectCity: "Select a city",
    bio: "Description (optional)",
    bioPlaceholder: "A short description members will see on the club page.",
    logo: "Logo",
    logoHint: "(optional, max 2MB)",
    chooseImage: "Choose image",
    changeImage: "Change image",
    remove: "Remove",
    create: "Create Club",
    creating: "Creating...",
    footnote:
      "You'll get an invite code to share with members. Anyone with the code can join.",
  },

  detail: {
    activities: "Club Activities",
    members: "Members",
    showingFirst: "Showing first {{shown}} of {{total}}",
    owner: "OWNER",
    leave: "Leave Club",
    delete: "Delete Club",
    confirmLeave: "Leave {{name}}?",
    confirmDelete: "Delete {{name}}? This cannot be undone.",
    inviteHint: "Share this code or the link with people you want to invite.",
  },

  join: {
    invitedTo: "You've been invited to",
    joinClub: "Join Club",
    joining: "Joining...",
    alreadyMember: "Already a Member — View Club",
    maybeLater: "Maybe later",
    cantJoin: "Can't join",
    invalidCode: "Invalid invite link",
  },
};

export const clubMatch = {
  title: "Club Match",
  titlePlural: "Club Matches",

  list: {
    empty: "No club matches yet.",
    emptyOwner: "No club matches yet. Challenge another club!",
    challenge: "+ Challenge",
    vsLabel: "vs",
  },

  status: {
    home_signup_open: "Home Roster Building",
    pending_acceptance: "Awaiting Opponent",
    rejected: "Rejected",
    away_signup_open: "Away Roster Building",
    scheduled: "Scheduled",
    in_progress: "In Progress",
    completed: "Completed",
    cancelled: "Cancelled",
  },

  new: {
    title: "New Club Match",
    subtitle: "Set the format, fill the home roster, then send the challenge.",
    yourClub: "Your Club",
    opponent: "Opponent Club",
    opponentCodeHint: "Opponent's invite code",
    find: "Find",
    change: "Change",
    date: "Date",
    location: "Location (optional)",
    locationPlaceholder: "e.g. Royal York Tennis Club",
    message: "Message (optional)",
    messagePlaceholder: "A note for the opponent owner.",
    composition: "Match Composition",
    addSlot: "+ Add slot",
    matchNum: "Match {{num}}",
    bestOf: "Best of {{n}}",
    oneSet: "1 set",
    create: "Create & Open Roster",
    creating: "Creating...",
    footnote:
      "Members of {{home}} will be able to volunteer for slots. Pick the final roster, then send the challenge to {{away}}.",
    notOwnerTitle: "Only club owners can start a club match",
    notOwnerBody:
      "Create a club first, or ask your club's owner to launch a challenge.",
    errors: {
      pickClub: "Pick your club",
      pickOpponent: "Pick an opponent club",
      noOpponent: "No club found for this code",
      ownClub: "Cannot challenge your own club",
      pickDate: "Pick a date",
      addSlot: "Add at least one slot",
    },
  },

  detail: {
    sendChallenge: "Send Challenge",
    pickHomeFirst: "Pick all home slots first",
    pickAwayFirst: "Pick all away slots first",
    accept: "Accept Challenge",
    reject: "Reject",
    confirmLineup: "Confirm Lineup",
    cancelMatch: "Cancel match",
    confirmCancel: "Cancel this club match?",
    recordScore: "Record Score",
    iWillPlay: "I'll play",
    withdraw: "Withdraw",
    pickPlayer: "Pick player",
    pickDoubles: "Pick doubles",
    waitingForSignups: "Waiting for signups",
    signedUpCount: "{{n}} signed up",
    matchHeader: "Match {{slot}} · {{category}} · BO{{bestOf}}",
    wonLabel: "{{name}} won",
    pickerTitle: "Pick player",
    pickerTitleDoubles: "Pick doubles pair",
    pickerHint: "Tap up to {{needed}} from the signup list.",
    pickerEmpty: "No signups yet. Ask members to volunteer.",
    confirm: "Confirm ({{selected}}/{{needed}})",
    pickExactly: "Pick exactly {{n}} {{noun}}.",
    scoreModalTitle: "Record Score",
    scoreModalSubtitle: "Match {{slot}} · BO{{bestOf}}",
    setLabel: "Set {{n}}",
    enterScores: "Enter set scores until someone wins the match",
    champion: "Champion",
    draw: "Draw",
  },

  categories: {
    mens_singles: "Men's Singles",
    womens_singles: "Women's Singles",
    mens_doubles: "Men's Doubles",
    womens_doubles: "Women's Doubles",
    mixed_doubles: "Mixed Doubles",
  },
};
